var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2092_20384",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2092_20384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95802 12.4554L14.9309 5.48263C15.1208 5.29271 15.3461 5.19775 15.6068 5.19775C15.8675 5.19775 16.0928 5.29271 16.2828 5.48263C16.4727 5.67255 16.5676 5.89786 16.5676 6.15859C16.5676 6.4193 16.4727 6.64461 16.2828 6.83452L8.62604 14.4912C8.43613 14.6811 8.21345 14.7761 7.95802 14.7761C7.70259 14.7761 7.47992 14.6811 7.29 14.4912L3.71663 10.9179C3.52671 10.7279 3.43439 10.5026 3.43967 10.2419C3.44496 9.9812 3.54256 9.75588 3.73248 9.56596C3.9224 9.37605 4.14772 9.28109 4.40844 9.28109C4.66915 9.28109 4.89446 9.37605 5.08438 9.56596L7.95802 12.4554Z",
    fill: "#2E3336"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4e344c36dc21bf3e5fcc7e5924ca71ec.svg";
export { ForwardRef as ReactComponent };